var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppliaLogoGradient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 230.1 74.8"
    },
    viewBox: "0 0 230.1 74.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#211c40}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9 70.1V56.7c0-.5.2-.7.7-.7h.7c.5 0 .7.2.7.7v5.8h7.7v-5.8c0-.5.2-.7.7-.7h.6c.4 0 .7.2.7.7v13.4c0 .5-.2.7-.7.7h-.7c-.5 0-.7-.2-.7-.7v-5.8H3.9v5.8c0 .5-.2.7-.7.7h-.6c-.5 0-.7-.2-.7-.7zM21.8 60c1.6 0 3 .5 4.1 1.6 1.1 1 1.7 2.4 1.7 4s-.6 2.9-1.7 4-2.4 1.6-4 1.6-2.9-.5-4-1.6-1.7-2.4-1.7-4 .6-2.9 1.7-4a5 5 0 0 1 3.9-1.6zm0 9.3c1 0 1.9-.4 2.6-1.1.7-.7 1.1-1.6 1.1-2.7s-.4-2-1.1-2.7a3.6 3.6 0 0 0-5.2 0c-.7.7-1.1 1.6-1.1 2.7s.4 2 1.1 2.7c.7.7 1.6 1.1 2.6 1.1zM29.7 70.1v-9.2c0-.5.2-.7.7-.7h.6c.5 0 .7.2.7.7v.9l-.1.6c.3-.7.8-1.2 1.4-1.7.7-.5 1.4-.8 2.2-.8 1.7 0 2.8.8 3.2 2.4a4 4 0 0 1 1.5-1.7c.7-.5 1.4-.7 2.3-.7 1.2 0 2.1.3 2.6 1 .6.7.8 1.7.8 3.1v6.1c0 .5-.2.7-.7.7h-.6c-.5 0-.7-.2-.7-.7v-5.6c0-.9-.1-1.6-.4-2-.3-.4-.8-.7-1.5-.7-.9 0-1.7.4-2.3 1.2-.6.8-.9 1.8-.9 2.8V70c0 .5-.2.7-.7.7h-.7c-.4 0-.7-.2-.7-.7v-5.6c0-.9-.1-1.6-.4-2-.3-.4-.7-.6-1.4-.6-.9 0-1.7.4-2.3 1.2-.6.8-.9 1.8-.9 2.8V70c0 .5-.2.7-.7.7h-.6c-.1.1-.4-.1-.4-.6zM47.9 65.5c0-1.6.5-3 1.5-4s2.3-1.5 3.8-1.5c1.4 0 2.6.5 3.3 1.4.8.9 1.2 2.1 1.2 3.6l-.2.5-.5.2h-7c.1 1.1.4 2 1.1 2.6.7.6 1.5.9 2.5.9.9 0 1.8-.3 2.5-.8.4-.2.7-.1.9.2l.2.3c.2.4.2.7-.2.9a5 5 0 0 1-3.5 1.2c-1.6 0-3-.5-4-1.6-1-1-1.6-2.3-1.6-3.9zm2.2-1.1h5.7c0-.9-.3-1.6-.8-2.1s-1.1-.7-1.8-.7c-.8 0-1.5.3-2 .8s-1 1.1-1.1 2zM64.3 70l4.8-13.4c.1-.4.4-.6.8-.6h1c.4 0 .6.2.8.6L76.5 70v.6c-.1.2-.3.2-.5.2h-.7c-.4 0-.6-.2-.8-.6l-1.3-3.7h-5.6l-1.3 3.7c-.1.4-.3.6-.8.6h-.7c-.3 0-.4-.1-.5-.2V70zm5.5-9.9-1.7 4.7h4.5L71 60.1l-.6-2.1-.6 2.1zM78.2 74.3V60.9c0-.5.2-.7.7-.7h.5c.5 0 .7.2.7.6V62l.5-.7c.8-.9 1.8-1.3 3.1-1.3 1.4 0 2.5.5 3.4 1.5.9 1 1.3 2.4 1.3 4s-.5 3-1.4 4c-.9 1-2 1.5-3.4 1.5-.8 0-1.5-.2-2-.6-.5-.4-.9-.7-1.1-1.1l-.1-.2.1.9v4.2c0 .5-.2.7-.7.7h-.6c-.7.1-1-.2-1-.6zm2-8.8c0 1 .3 1.9.8 2.6.5.7 1.3 1.1 2.2 1.1.9 0 1.6-.3 2.2-1a4 4 0 0 0 .9-2.7c0-1.1-.3-2-.8-2.7-.6-.7-1.3-1-2.2-1-.9 0-1.6.3-2.2 1-.6.6-.9 1.5-.9 2.7zM90.6 74.3V60.9c0-.5.2-.7.7-.7h.5c.5 0 .7.2.7.6V62l.5-.7c.8-.9 1.8-1.3 3.1-1.3 1.4 0 2.5.5 3.4 1.5.9 1 1.3 2.4 1.3 4s-.5 3-1.4 4c-.9 1-2 1.5-3.4 1.5-.8 0-1.5-.2-2-.6-.5-.4-.9-.7-1.1-1.1l-.1-.2.1.9v4.2c0 .5-.2.7-.7.7h-.6c-.8.1-1-.2-1-.6zm2-8.8c0 1 .3 1.9.8 2.6.5.7 1.3 1.1 2.2 1.1.9 0 1.6-.3 2.2-1a4 4 0 0 0 .9-2.7c0-1.1-.3-2-.8-2.7-.6-.7-1.3-1-2.2-1-.9 0-1.6.3-2.2 1-.6.6-.9 1.5-.9 2.7zM103 67.9V56.7c0-.5.2-.7.7-.7h.6c.5 0 .7.2.7.7v10.9c0 .9.3 1.3 1 1.4.4 0 .5.2.5.6v.5c0 .5-.2.7-.7.7-1.9.1-2.8-.9-2.8-2.9zM109.8 58.1h-.7c-.5 0-.7-.2-.7-.7v-.7c0-.5.2-.7.7-.7h.7c.5 0 .7.2.7.7v.7c0 .5-.2.7-.7.7zm-1.4 12v-9.2c0-.5.2-.7.7-.7h.6c.5 0 .7.2.7.7v9.2c0 .5-.2.7-.7.7h-.6c-.4 0-.7-.2-.7-.7zM112.5 67.9c0-.6.1-1.1.4-1.6.3-.5.7-.8 1.1-1.1l1.6-.6c.9-.2 2-.4 3.2-.4h.5V64c0-1.5-.8-2.3-2.3-2.3-.8 0-1.6.2-2.4.7-.4.2-.7.1-.9-.3l-.2-.3c-.2-.4-.1-.7.2-.9a7 7 0 0 1 3.4-.9c1.3 0 2.4.4 3.1 1.1s1.1 1.7 1.1 3.1v6c0 .5-.2.7-.7.7h-.5c-.5 0-.7-.2-.7-.7v-.6l.1-.6-.5.8c-.7 1-1.7 1.4-2.9 1.4-1 0-1.8-.3-2.5-.9a3.4 3.4 0 0 1-1.1-2.4zm2.1-.2c0 .5.2.9.5 1.2.4.3.8.5 1.4.5.8 0 1.5-.3 2-1a4 4 0 0 0 .8-2.3v-.5h-.5c-2.8 0-4.2.7-4.2 2.1zM124.2 70.1v-9.2c0-.5.2-.7.7-.7h.6c.5 0 .7.2.7.7v.9l-.1.6c.3-.6.7-1.2 1.4-1.7s1.6-.8 2.6-.8c2.4 0 3.6 1.4 3.6 4.1v6.1c0 .5-.2.7-.7.7h-.6c-.5 0-.7-.2-.7-.7v-5.6c0-.9-.1-1.6-.4-2-.3-.4-.8-.6-1.6-.6-1 0-1.9.4-2.5 1.1s-1 1.7-1 2.8v4.4c0 .5-.2.7-.7.7h-.6c-.5-.1-.7-.3-.7-.8zM135.9 65.5c0-1.6.5-2.9 1.6-4a5.4 5.4 0 0 1 4.1-1.6c1.4 0 2.5.4 3.5 1.1.4.2.4.5.1.9l-.2.3c-.2.3-.5.4-.9.2a4 4 0 0 0-2.4-.8 3.6 3.6 0 0 0-3.6 3.8c0 1.1.3 2 1 2.7.7.7 1.6 1.1 2.7 1.1.9 0 1.8-.3 2.7-1 .4-.3.7-.2.9.2l.2.3c.2.4.2.7-.2.9a5.7 5.7 0 0 1-3.8 1.3c-1.7 0-3-.5-4.1-1.6-1.1-.9-1.6-2.2-1.6-3.8zM146.9 65.5c0-1.6.5-3 1.5-4s2.3-1.5 3.8-1.5c1.4 0 2.6.5 3.3 1.4.8.9 1.2 2.1 1.2 3.6l-.2.5-.5.2h-7c.1 1.1.4 2 1.1 2.6.7.6 1.5.9 2.5.9.9 0 1.8-.3 2.5-.8.4-.2.7-.1.9.2l.2.3c.2.4.2.7-.2.9a5.9 5.9 0 0 1-3.6 1.1c-1.6 0-3-.5-4-1.6-1-.9-1.5-2.2-1.5-3.8zm2.1-1.1h5.7c0-.9-.3-1.6-.8-2.1s-1.1-.7-1.8-.7c-.8 0-1.5.3-2 .8s-.9 1.1-1.1 2zM164.6 70.1V56.7c0-.5.2-.7.7-.7h7.2c.5 0 .7.2.7.7v.4c0 .5-.2.7-.7.7h-5.8v4.6h4.6c.5 0 .7.2.7.7v.4c0 .5-.2.7-.7.7h-4.6V69h6.2c.5 0 .7.2.7.7v.4c0 .5-.2.7-.7.7h-7.5c-.6 0-.8-.2-.8-.7zM175.4 67v-6.1c0-.5.2-.7.7-.7h.6c.4 0 .7.2.7.7v5.6c0 .9.2 1.5.5 2 .3.4.8.7 1.5.7a3 3 0 0 0 2.5-1.2c.6-.8.9-1.7.9-2.8v-4.3c0-.5.2-.7.7-.7h.6c.5 0 .7.2.7.7v9.2c0 .5-.2.7-.7.7h-.6c-.5 0-.7-.2-.7-.7v-.9l.1-.6c-.3.6-.8 1.2-1.5 1.7s-1.5.8-2.5.8c-2.3-.1-3.5-1.4-3.5-4.1zM187.8 70.1v-9.2c0-.5.2-.7.7-.7h.6c.5 0 .7.2.7.7v1.2l-.1.8c.3-.8.7-1.5 1.3-2a3 3 0 0 1 2-.8c.4 0 .7.2.7.7v.6c0 .5-.3.7-.8.7-1 0-1.7.4-2.3 1.3-.5.9-.8 1.9-.8 3v3.7c0 .5-.2.7-.7.7h-.6c-.4 0-.7-.2-.7-.7zM199.9 60c1.6 0 3 .5 4.1 1.6 1.1 1 1.7 2.4 1.7 4s-.6 2.9-1.7 4-2.4 1.6-4 1.6-2.9-.5-4-1.6-1.7-2.4-1.7-4 .6-2.9 1.7-4a5 5 0 0 1 3.9-1.6zm0 9.3c1 0 1.9-.4 2.6-1.1.7-.7 1.1-1.6 1.1-2.7s-.4-2-1.1-2.7a3.6 3.6 0 0 0-5.2 0c-.7.7-1.1 1.6-1.1 2.7s.4 2 1.1 2.7c.7.7 1.6 1.1 2.6 1.1zM207.8 74.3V60.9c0-.5.2-.7.7-.7h.5c.5 0 .7.2.7.6V62l.5-.7c.8-.9 1.8-1.3 3.1-1.3 1.4 0 2.5.5 3.4 1.5.9 1 1.3 2.4 1.3 4s-.5 3-1.4 4c-.9 1-2 1.5-3.4 1.5-.8 0-1.5-.2-2-.6-.5-.4-.9-.7-1.1-1.1l-.1-.2.1.9v4.2c0 .5-.2.7-.7.7h-.6c-.7.1-1-.2-1-.6zm2-8.8c0 1 .3 1.9.8 2.6.5.7 1.3 1.1 2.2 1.1.9 0 1.6-.3 2.2-1a4 4 0 0 0 .9-2.7c0-1.1-.3-2-.8-2.7-.6-.7-1.3-1-2.2-1-.9 0-1.6.3-2.2 1-.6.6-.9 1.5-.9 2.7zM219.5 65.5c0-1.6.5-3 1.5-4s2.3-1.5 3.8-1.5c1.4 0 2.6.5 3.3 1.4.8.9 1.2 2.1 1.2 3.6l-.2.5-.5.2h-7.1c.1 1.1.4 2 1.1 2.6.7.6 1.5.9 2.5.9.9 0 1.8-.3 2.5-.8.4-.2.7-.1.9.2l.2.3c.2.4.2.7-.2.9a5.9 5.9 0 0 1-3.6 1.1c-1.6 0-3-.5-4-1.6a5.7 5.7 0 0 1-1.4-3.8zm2.2-1.1h5.7c0-.9-.3-1.6-.8-2.1s-1.1-.7-1.8-.7c-.8 0-1.5.3-2 .8s-1 1.1-1.1 2z",
    className: "st0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 25.8,
    x2: 25.8,
    y1: 48.5,
    y2: 0.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#234e9c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3bb3e4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 48.4c-3.8 0-4.7-2.2-2-4.9l40-40C44.1 1.8 45.7 1 47.2 1c1 0 1.8.4 2.5 1.1.7.7 1 1.8 1 3v40.4c0 1.6-1.3 2.9-2.9 2.9h-2.5a2.9 2.9 0 0 1-2.9-2.9V24.1l-8.7.1-23.3 23.4c-.5.5-1.4.8-2 .8H4.5z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105384569870752464450000007705477570557986694_",
    x1: 205.2,
    x2: 205.2,
    y1: 48.5,
    y2: 0.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#234e9c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3bb3e4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M226.6 48.4c3.8 0 4.7-2.2 2-4.9l-40.1-40c-1.6-1.6-3.2-2.4-4.7-2.4-1 0-1.8.4-2.5 1.1-.7.7-1 1.8-1 3v40.4c0 1.6 1.3 2.9 2.9 2.9h2.5c1.6 0 2.9-1.3 2.9-2.9V24.1l8.7.1 23.4 23.4c.5.5 1.4.8 2 .8h3.9z",
    style: {
      fill: "url(#SVGID_00000105384569870752464450000007705477570557986694_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142864484710686768270000017231309313535189383_",
    x1: 76.3,
    x2: 76.3,
    y1: 48.5,
    y2: 0.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#234e9c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3bb3e4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.9 35.1v10.4c0 1.6-1.3 2.9-2.9 2.9h-2.5a2.9 2.9 0 0 1-2.9-2.9V6.8c0-3.2 2.6-5.7 5.7-5.7h8.5c5.9 0 10.7 1.8 14.2 5.3 3.2 3.2 4.7 7.1 4.7 11.7s-1.6 8.5-4.7 11.7a19.3 19.3 0 0 1-14.2 5.3h-5.9zm7.3-8.2c3 0 5.4-.9 7.3-2.8 1.6-1.7 2.4-3.7 2.4-6.1s-.9-4.4-2.5-6a9.8 9.8 0 0 0-7.3-2.7h-7.3v17.6h7.4z",
    style: {
      fill: "url(#SVGID_00000142864484710686768270000017231309313535189383_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031197415684292070290000005002350629526351238_",
    x1: 114.6,
    x2: 114.6,
    y1: 48.5,
    y2: 0.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#234e9c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3bb3e4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.3 35.1v10.4c0 1.6-1.3 2.9-2.9 2.9h-2.5a2.9 2.9 0 0 1-2.9-2.9V3.9c0-1.6 1.3-2.9 2.9-2.9h11.4c5.9 0 10.7 1.8 14.2 5.3 3.2 3.2 4.7 7.1 4.7 11.7s-1.6 8.5-4.7 11.7a19.3 19.3 0 0 1-14.2 5.3h-6zm7.2-8.2c3 0 5.4-.9 7.3-2.8 1.6-1.7 2.4-3.7 2.4-6.1s-.8-4.4-2.4-6.1a9.8 9.8 0 0 0-7.3-2.7h-7.3v17.6h7.3z",
    style: {
      fill: "url(#SVGID_00000031197415684292070290000005002350629526351238_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032645877169397817040000004914495147163660958_",
    x1: 148.9,
    x2: 148.9,
    y1: 48.5,
    y2: 0.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#234e9c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3bb3e4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.4 45.5V3.9c0-1.6 1.3-2.9 2.9-2.9h2.5c1.6 0 2.9 1.3 2.9 2.9v36.3h10c1.6 0 2.9 1.3 2.9 2.9v2.5c0 1.6-1.3 2.9-2.9 2.9h-15.3c-1.7-.1-3-1.4-3-3z",
    style: {
      fill: "url(#SVGID_00000032645877169397817040000004914495147163660958_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180350202396678176190000008372869232667223222_",
    x1: 168.9,
    x2: 168.9,
    y1: 48.5,
    y2: 0.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#234e9c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3bb3e4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.8 45.5V15c0-1.6 1.3-2.9 2.9-2.9h2.5c1.6 0 2.9 1.3 2.9 2.9v30.5c0 1.6-1.3 2.9-2.9 2.9h-2.5a2.9 2.9 0 0 1-2.9-2.9z",
    style: {
      fill: "url(#SVGID_00000180350202396678176190000008372869232667223222_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039821820746311014360000000860018140286012318_",
    x1: 168.9,
    x2: 168.9,
    y1: 48.5,
    y2: 0.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#234e9c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3bb3e4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164 4.7V3.4c0-1.9 1.5-3.4 3.4-3.4h3c1.9 0 3.4 1.5 3.4 3.4v1.3c0 1.9-1.5 3.4-3.4 3.4h-3a3.4 3.4 0 0 1-3.4-3.4z",
    style: {
      fill: "url(#SVGID_00000039821820746311014360000000860018140286012318_)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliaLogoGradient);
export default __webpack_public_path__ + "static/media/applia_logo_gradient.b025072f4abec5e929574f9b8652d464.svg";
export { ForwardRef as ReactComponent };